import Vue from 'vue'
import Vuex from 'vuex'

/**
 * 用户token
 */
const USER_NAME = `${process.env.VUE_APP_NAME}token`;
/**
 * 语言名称
 */
const LANG_NAME = "USER_LANGUAGE";

Vue.use(Vuex)

let $i18n = null;

function loadStores() {
  const locales = require.context('./modules/', true, /[A-Za-z0-9-_,\s]+\.js$/i)
  const obj = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      obj[locale] = locales(key).default
    }
  })
  return obj
}

const modules = loadStores();

const store = new Vuex.Store({
  state: {
    user: localStorage.getItem(`${process.env.VUE_APP_NAME}token`) || '',
    isLoadding: false,
    showLoading: false,
    language: localStorage.getItem(LANG_NAME) || 'zh',
    keepAliveRouteNames: [],
    token: localStorage.getItem(`${process.env.VUE_APP_NAME}token`) || '',
  },
  getters: {
    isLoggedIn(state) {

      return !!state.token && !!state.wallet?.account
    },
    isOnBsc(state) {
      console.log('isOnBsc', state.wallet?.chainId)
      return ['0x38'].includes(state.wallet?.chainId)

    },

  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem(`${process.env.VUE_APP_NAME}token`, token)
      console.log('SET_TOKEN', token)
    },
    REMOVE_TOKEN(state) {
      state.token = ''
      localStorage.removeItem(`${process.env.VUE_APP_NAME}token`);
      console.log('REMOVE_TOKEN')
    },


    // setUser(user) {
    //   console.log('setUser', user)
    //   // if (!user.startsWith('Bearer ')) {
    //   //   user = 'Bearer ' + user;
    //   // }
    //   state.user = user

    //   localStorage.setItem(`${process.env.VUE_APP_NAME}token`, user)
    // },
    // removeUser(state) {
    //   state.user = '';
    //   localStorage.removeItem(`${process.env.VUE_APP_NAME}token`);
    // },
    setLanguage(state, lang) {
      state.language = lang;
      $i18n.locale = lang;
      localStorage.setItem(LANG_NAME, lang);
    },
  },
  actions: {},
  modules: modules
});

export default store;

export function setI18n(i18n) {
  $i18n = i18n;
}
